if (window.location.pathname !== '/pages/b2b') {
  const selector = '[form-id="30032"]';
  let elapsed = 0;
  const intervalTime = 100;

  const interval = setInterval(() => {
    const target = document.querySelector(selector);
    elapsed += intervalTime;

    if (target) {
      target.remove();
      clearInterval(interval);
      console.log('Element found and removed. Interval cleared.');
    }

    if (elapsed >= 6000) {
      clearInterval(interval);
      console.log('6s passed. Interval auto-cleared.');
    }
  }, intervalTime);
}